// src/redux/sagas/index.ts
import { all, fork } from 'redux-saga/effects';
import { providerSearchSaga } from './providerSearchSagas';

export default function* rootSaga() {
  yield all([
    fork(providerSearchSaga),
    // Add other sagas here
  ]);
}